import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { STEPS, DELIVERABLES } from "@/data/content";
import { FileCheck2 } from "lucide-react";
import { Reveal, MaskLine, Eyebrow } from "./Reveal";

export const Method = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const line = useTransform(scrollYProgress, [0.2, 0.7], ["0%", "100%"]);

  return (
    <section id="metodo" ref={ref} data-testid="method-section" className="relative bg-[var(--ink)] py-24 md:py-36 overflow-hidden">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <div className="relative overflow-hidden rounded-sm h-[340px] md:h-[480px] mb-20 md:mb-28 grain">
          <motion.img style={{ y: imgY }} src="/assets/machinery.jpg" alt="Planta industrial" className="absolute inset-0 w-full h-[120%] -top-[10%] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[var(--ink)] via-[var(--ink)]/70 to-transparent" />
          <div className="relative h-full flex items-center p-6 md:p-14">
            <blockquote data-testid="method-quote" className="font-display font-black uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.92] max-w-3xl">
              <MaskLine inView>Soluções técnicas</MaskLine>
              <MaskLine inView delay={0.1}><span className="steel-text">para um futuro mais</span></MaskLine>
              <MaskLine inView delay={0.2}><span className="text-[var(--amber)]">seguro e eficiente.</span></MaskLine>
            </blockquote>
          </div>
        </div>

        <Reveal><Eyebrow testid="method-eyebrow">Método · Como trabalhamos</Eyebrow></Reveal>
        <div className="relative mt-12">
          <div className="hidden lg:block absolute top-0 left-0 right-0 h-px bg-white/10">
            <motion.div style={{ width: line }} className="h-px bg-[var(--cyan)]" />
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1} className="lg:pt-10 border-t border-white/10 lg:border-t-0 pt-6" >
                <div data-testid={`method-step-${s.n}`}>
                  <span className="font-mono text-sm text-[var(--cyan)]">{s.n}</span>
                  <h3 className="mt-4 font-display text-3xl font-extrabold uppercase text-white">{s.title}</h3>
                  <p className="mt-3 text-[var(--steel-2)] leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal className="mt-20">
          <div data-testid="deliverables" className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
            <div className="bg-[var(--navy)] p-6 font-mono text-xs uppercase tracking-[0.2em] text-[var(--amber)] flex items-center">Entregue em cada projeto</div>
            {DELIVERABLES.map((d) => (
              <div key={d} className="bg-[var(--ink)] p-6 flex items-center gap-3 text-white"><FileCheck2 size={18} className="text-[var(--cyan)] shrink-0" />{d}</div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
